export default __webpack_public_path__ + "static/media/icon-benchToShoulder.122ae573.svg";